/* eslint-disable indent */
import axios from 'axios';
import { proxy } from 'valtio/vanilla';
import { userAuthUrl } from '../constants/url-constants';

export const proxyAuthState = proxy({
    accessToken: '',
    expiresIn: 300,
    isLoggedIn: true
});

const DEBUG = process.env.NODE_ENV === 'development2';
let BASE_API_URL = userAuthUrl();

/* Create axios instance */
const api = axios.create({
    baseURL: BASE_API_URL,
    headers: {
        'Content-Type': 'application/json',
        X_VEHICLE_TYPE: 'CAR',
        X_COUNTRY: 'AE'
    },
    withCredentials: true
});

/**
 * Passes response.data to services.
 * In dev, intercepts response and logs it into console for dev
 */
api.interceptors.response.use((response) => {
    if (DEBUG) { console.info('📩 ', response); }
    return response;
}, (error) => {
    if (error.response && error.response.data) {
        if (DEBUG) { console.error('Error: ', error.response.data); }
        return Promise.reject(error.response.data);
    }
    if (DEBUG) { console.error('📩 ', error); }
    return Promise.reject(error.message);
});

export default api;
